import Alert from "@mui/material/Alert";
import { ComponentProps } from "../types";

function Component({ component }: ComponentProps) {
	return <Alert key={component.id} />;
}

export default Component;
